<!-- this component enables browser-preview of the actual component -->
<template>
  <div id="app">
    <router-view></router-view>
    <tracking-pixels></tracking-pixels>
  </div>
</template>

<script>
import Tracking from 'pkg-bea-tracking'
const { trackingPixels } = Tracking
export default {
  components: { trackingPixels },
}
</script>

<style lang="sass">
  $blue: #3da2dc
  $dark-blue: #004461
  $black: #000
  
  @font-face
    font-family: 'Open Sans'
    font-style: normal
    font-weight: 400
    src: local('Open Sans'), local('OpenSans'),  url('https://carol.cruise-api.aida.de/i18n-bea/de/defaultfont-regular-woff2-wfs6ew-original.woff2') format('woff2'), url('https://carol.cruise-api.aida.de/i18n-bea/de/defaultfont-regular-woff-xx167z-original.woff') format('woff')

  @font-face 
    font-family: 'Open Sans'
    font-style: normal
    font-weight: 700
    src: local('Open Sans Bold'), local('OpenSans-Bold'), url('https://carol.cruise-api.aida.de/i18n-bea/de/defaultfont-w700-woff2-3a75bm-original.woff2') format('woff2'), url('https://carol.cruise-api.aida.de/i18n-bea/de/defaultfont-w700-woff-bz9dkb-original.woff') format('woff')
  body
    font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif
    color: $dark-blue
  .body
    background-color: $blue
    height: 1000px
    font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif
    //color: $black

</style>

